var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorUserList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0501 13.6307C16.6834 13.5163 16.2918 13.4546 15.8847 13.4546C13.8045 13.4546 12.1179 15.0688 12.1179 17.0603C12.1179 17.9558 12.4584 18.7735 13.0227 19.4035H5.70595C5.31637 19.4035 5 19.1225 5 18.7767V15.8633C5 13.7676 6.17614 12.0686 9.27733 12.0686H13.3357C15.2937 12.0686 16.4443 12.6838 17.0495 13.6314L17.0501 13.6307Z",
    fill: "url(#paint0_linear_468_75954)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6735 10.5694C13.863 10.2141 15.3499 8.1518 14.9945 5.96307C14.639 3.77435 12.576 2.28805 10.3864 2.64333C8.19686 2.99861 6.70999 5.06093 7.06541 7.24966C7.42082 9.43838 9.48393 10.9247 11.6735 10.5694Z",
    fill: "url(#paint1_linear_468_75954)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6711 20.6786C17.7164 20.6786 19.3742 19.02 19.3738 16.974C19.3735 14.928 17.7151 13.2694 15.6698 13.2694C13.6245 13.2694 11.9668 14.928 11.9671 16.974C11.9675 19.02 13.6258 20.6786 15.6711 20.6786Z",
    fill: "url(#paint2_linear_468_75954)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6769 20.7014C13.6234 20.7014 11.9524 19.0317 11.9524 16.9783C11.9524 14.925 13.6228 13.2552 15.6769 13.2552C17.731 13.2552 19.4013 14.925 19.4013 16.9783C19.4013 19.0317 17.731 20.7014 15.6769 20.7014ZM15.6769 13.2955C13.6452 13.2955 11.992 14.9481 11.992 16.979C11.992 19.0099 13.6452 20.6625 15.6769 20.6625C17.7085 20.6625 19.3617 19.0099 19.3617 16.979C19.3617 14.9481 17.7085 13.2955 15.6769 13.2955Z",
    fill: "url(#paint3_linear_468_75954)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 16.125C13.5 15.9179 13.6679 15.75 13.875 15.75H17.125C17.3321 15.75 17.5 15.9179 17.5 16.125C17.5 16.3321 17.3321 16.5 17.125 16.5H13.875C13.6679 16.5 13.5 16.3321 13.5 16.125Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 17.875C13.5 17.6679 13.6931 17.5 13.9312 17.5H15.3687C15.6069 17.5 15.8 17.6679 15.8 17.875C15.8 18.0821 15.6069 18.25 15.3687 18.25H13.9312C13.6931 18.25 13.5 18.0821 13.5 17.875Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_468_75954",
    x1: 6.37596,
    y1: 10.6631,
    x2: 12.2788,
    y2: 28.0916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59E3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BD64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_468_75954",
    x1: 7.08063,
    y1: 1.62091,
    x2: 18.6014,
    y2: 16.2078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59E3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17BD64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_468_75954",
    x1: 11.9671,
    y1: 16.9742,
    x2: 19.3738,
    y2: 16.9729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_468_75954",
    x1: 11.9524,
    y1: 16.9785,
    x2: 19.4013,
    y2: 16.9785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E7E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorUserList);
export default __webpack_public_path__ + "static/media/color-user-list.fa59f87fce79dac2c10772c913d19c78.svg";
export { ForwardRef as ReactComponent };